import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <defs>
                <filter id="filter4060" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4066" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4072" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4078" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4084" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4090" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4096" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4102" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4108" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4114" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4120" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4126" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4126-7" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4126-9" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4126-5" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <filter id="filter4126-6" width="1" height="1" x="0" y="0" colorInterpolationFilters="sRGB">
                    <feColorMatrix result="fbSourceGraphic" type="saturate" values="1"></feColorMatrix>
                    <feColorMatrix
                        in="fbSourceGraphic"
                        values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                    ></feColorMatrix>
                </filter>
                <clipPath id="clipPath7453" clipPathUnits="userSpaceOnUse">
                    <rect
                        width="743.244"
                        height="1055.244"
                        x="186.578"
                        y="-3.26"
                        fill="#fff"
                        fillOpacity="1"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="28.421"
                        ry="28.413"
                    ></rect>
                </clipPath>
            </defs>
            <g transform="translate(-186.578 -718.984)">
                <g
                    fillOpacity="1"
                    strokeWidth="3.173"
                    clipPath="url(#clipPath7453)"
                    transform="matrix(.31484 0 0 .31557 127.836 720.013)"
                >
                    <rect
                        width="743.244"
                        height="1055.244"
                        x="179.407"
                        y="-3.26"
                        fill="#fff"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="2.398"
                        rx="28.421"
                        ry="28.413"
                    ></rect>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .7666 -31.754 -333.712)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4126-9)"
                        transform="matrix(.78463 0 0 .8478 112.884 -377.447)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .8478 36.94 -305.266)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4126-6)"
                        transform="matrix(.78463 0 0 .8478 495.259 -367.472)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4126-7)"
                        transform="matrix(.78463 0 0 .8478 357.271 -365.81)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4126-5)"
                        transform="matrix(.78463 0 0 .8478 232.584 -379.11)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4126)"
                        transform="matrix(.78463 0 0 .8478 297.63 -305.266)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4120)"
                        transform="matrix(.78463 0 0 .8478 167.285 -305.266)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .7666 628.259 -310.437)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .8478 556.572 -305.266)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .8478 427.977 -305.266)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .8478 -95.06 -305.266)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" filter="url(#filter4114)" transform="matrix(.78463 0 0 .7666 60.94 -204.08)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .7666 321.63 -204.08)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .7666 191.285 -204.08)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .7666 580.572 -204.08)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .7666 451.977 -204.08)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.78463 0 0 .7666 -71.06 -204.08)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.96868 0 0 .94642 -167.748 -206.548)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.96868 0 0 .94642 154.093 -206.548)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4108)"
                        transform="matrix(.96868 0 0 .94642 -6.828 -206.548)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.96868 0 0 .94642 473.774 -206.548)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(.96868 0 0 .94642 315.014 -206.548)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.0763 0 0 1.05157 -132.513 -181.881)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.0763 0 0 1.05157 225.088 -181.881)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4102)"
                        transform="matrix(1.0763 0 0 1.05157 46.288 -181.881)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.0763 0 0 1.05157 -246.513 -93.95)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.0763 0 0 1.05157 403.89 -181.881)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4096)"
                        transform="matrix(1.0763 0 0 1.05157 111.088 -93.95)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.0763 0 0 1.05157 -67.712 -93.95)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.0763 0 0 1.05157 466.29 -93.95)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.0763 0 0 1.05157 289.89 -93.95)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.1959 0 0 1.16842 -228.03 -46.784)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4090)"
                        transform="matrix(1.1959 0 0 1.16842 169.306 -46.784)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.1959 0 0 1.16842 -29.362 -46.784)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.1959 0 0 1.16842 367.973 -46.784)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.1959 0 0 1.24961 -334.03 25.94)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.1959 0 0 1.24961 63.306 25.94)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.1959 0 0 1.24961 -135.362 25.94)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.1959 0 0 1.24961 457.973 25.94)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4084)"
                        transform="matrix(1.1959 0 0 1.24961 261.973 25.94)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.4877 -296.38 44.823)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4078)"
                        transform="matrix(1.32878 0 0 1.4877 145.102 44.823)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.4877 -75.64 44.823)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.4877 365.844 44.823)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.4065 -220.38 181.182)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.4065 293.844 181.182)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4072)"
                        transform="matrix(1.32878 0 0 1.4065 32.732 181.182)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.39297 -296.38 299.331)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4066)"
                        transform="matrix(1.32878 0 0 1.39297 145.102 299.331)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.39297 -75.64 299.331)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.29824 -220.38 434.643)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.39297 365.844 299.331)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g
                        strokeWidth="3.21"
                        filter="url(#filter4060)"
                        transform="matrix(1.32878 0 0 1.29824 293.844 434.643)"
                    >
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                    <g strokeWidth="3.21" transform="matrix(1.32878 0 0 1.29824 32.732 434.643)">
                        <path
                            fill="#c59e42"
                            d="M400.656 355.781c-66.587 0-120.637 53.612-121.344 120.031h242.72c-.707-66.42-54.789-120.03-121.376-120.03z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.658 367.784c-59.928 0-108.574 48.25-109.21 108.029h218.447c-.636-59.778-49.309-108.029-109.237-108.029z"
                        ></path>
                        <path
                            fill="#c6a148"
                            d="M400.66 378.587c-53.936 0-97.717 43.426-98.29 97.226h196.603c-.572-53.8-44.378-97.226-98.314-97.226z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.66 388.31c-48.541 0-87.944 39.083-88.46 87.502h176.943c-.515-48.42-39.94-87.502-88.483-87.502z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.662 397.06c-43.688 0-79.15 35.175-79.614 78.752h159.248c-.464-43.577-35.947-78.752-79.634-78.752z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.663 411.235c-35.823 0-64.903 28.844-65.283 64.578h130.583c-.38-35.734-29.476-64.578-65.3-64.578z"
                        ></path>
                        <path
                            fill="#c59e42"
                            d="M400.665 425.442c-27.942 0-50.624 22.498-50.92 50.37h101.854c-.296-27.872-22.991-50.37-50.934-50.37z"
                        ></path>
                        <path
                            fill="#e6e6e6"
                            d="M400.667 438.035c-20.957 0-37.968 16.873-38.19 37.777h76.39c-.222-20.904-17.243-37.777-38.2-37.777z"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
